/**
 * Lógica PURA del CENTRO DE NOTIFICACIONES (👥 Wave 1, agente D). Sin acceso a
 * DB: se testea aislada (progress-style). Los tipos de notificación son estables
 * (la traducción del verbo vive en la UI con lingui).
 */

export type NotificationKind = "follow" | "like" | "mention" | "tag" | "message";

/** Normaliza el `kind` crudo de la fila a un tipo conocido (fallback `follow`). */
export function notificationKind(kind: string | null | undefined): NotificationKind {
  switch (kind) {
    case "like":
    case "mention":
    case "tag":
    case "message":
    case "follow": {
      return kind;
    }
    default: {
      return "follow";
    }
  }
}

/** Nº de notificaciones sin leer (para el badge del centro). */
export function unreadNotificationCount(rows: readonly { read_at: string | null }[]): number {
  return rows.reduce((n, r) => (r.read_at == null ? n + 1 : n), 0);
}

/** ¿Hay alguna sin leer? (barato, corta al primer hallazgo). */
export function hasUnreadNotifications(rows: readonly { read_at: string | null }[]): boolean {
  return rows.some((r) => r.read_at == null);
}
